import { ProductCategoriesControllerFindAll$Params } from '@klubovna/api-client';
import { ProductCategory } from '@klubovna/api-client';
import { PaginatedResponse } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';

export const ADMIN_PRODUCT_CATEGORIES_ID = '[Product Categories admin]';

export const loadProductCategories = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Load Product Categories',
  props<{ params?: ProductCategoriesControllerFindAll$Params }>(),
);

export const loadProductCategoriesSuccess = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Load Product Categories Success',
  props<{ response: PaginatedResponse<ProductCategory> }>(),
);

export const loadProductCategoriesFailure = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Load Product Categories Failure',
  props<{ error: string }>(),
);

export const createProductCategory = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Create Product Category',
  props<{ categoryData: CreateProductCategoryData }>(),
);

export const createProductCategorySuccess = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Create Product Category Success',
  props<{ category: ProductCategory }>(),
);

export const createProductCategoryFailure = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Create Product Category Failure',
  props<{ error: string }>(),
);

export const updateProductCategory = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Update Product Category',
  props<{ id: string; categoryData: UpdateProductCategoryData }>(),
);

export const updateProductCategorySuccess = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Update Product Category Success',
  props<{ category: ProductCategory }>(),
);

export const updateProductCategoryFailure = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Update Product Category Failure',
  props<{ error: string }>(),
);

export const deleteProductCategory = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Delete Product Category',
  props<{ id: string }>(),
);

export const deleteProductCategorySuccess = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Delete Product Category Success',
  props<{ id: string }>(),
);

export const deleteProductCategoryFailure = createAction(
  ADMIN_PRODUCT_CATEGORIES_ID + ' Delete Product Category Failure',
  props<{ error: string }>(),
);

export interface CreateProductCategoryData {
  name: string;
  sortOrder?: number;
  isActive?: boolean;
}

export interface UpdateProductCategoryData {
  name?: string;
  sortOrder?: number;
  isActive?: boolean;
}
